export const defaultPagination = {
  page: 1,
  pageSize: 100,
};

export const defaultFilters = {
  name: null,
  type: null,
  feed: null,
  vendor: null,
  last_seen_from: null,
  last_seen_to: null,
  totalRange: [0, 100],
  totalCustomRange: [0, 100],
  totalIocRange: [0, 100],
  totalFeedRange: [0, 100],
};

export const defaultExploreFilters = {
  query: null,
  answer: null,
  count_from: null,
  count_to: null,
  feed: null,
  type: null,
  last_seen_from: null,
  last_seen_to: null,
  first_seen_from: null,
  first_seen_to: null,
};

export const defaultSorting = {
  total: null,
  totalCustom: null,
  totalIoc: '-total_ioc',
  totalSourceScore: '-total_source_score',
};

export const defaultExploreSorting = null;

export const defaultFilterSettings = {
  feedsources: [],
  vendors: [],
  types: [],
  customIndicatorsScore: { min: 0, max: 100 },
  sourceScore: { min: 0, max: 100 },
  secondaryIndicatorsScore: { min: 0, max: 100 },
  totalScore: { min: 0, max: 100 },
};

export const defaultSpecificFilterSettings = {
  asnOptions: [],
};
